export default "__VITE_ASSET__DniX2i5A__"